<template>
  <div v-if="currentComp === 'TABLE'" class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入关键字"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择组织级别"
        v-model="searchData.organizationLevel"
        clearable
      >
        <el-option
          v-for="item in levelList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-input-number
        controls-position="right"
        size="small"
        class="mr-10px !w-50 mb-10px"
        :min="1"
        v-model="searchData.inspectionCycle"
        placeholder="请选择排查周期"
        :precision="0"
        clearable
      ></el-input-number>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查周期单位"
        v-model="searchData.unitCycle"
        clearable
      >
        <el-option
          v-for="item in unitCycleList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.troubleshootingType"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查类型"
        clearable
      >
        <el-option
          v-for="item in checkTypeList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="searchList()">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :data="tableData"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="loading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="基础管理排查项目"
          prop="screeningItems"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
        <el-table-column
          label="项目编码"
          width="180"
          prop="projectCode"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="排查内容"
          prop="troubleshootingContent"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="排查标准"
          prop="screeningCriteria"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="组织级别"
          width="180"
          prop="organizationalLevel"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="排查周期"
          prop="troubleshootingCycle"
          width="180"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.taskSource === 0">{{ scope.row.troubleshootingCycle }}</span>
            <span v-else>/</span>
          </template>
        </el-table-column>
        <el-table-column
          label="排查类型"
          width="120"
          prop="troubleshootingType"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ checkTypeListMap(scope.row.troubleshootingType) }}
          </template>
        </el-table-column>
        <el-table-column
          label="排查人"
          prop="deadlinePersonName"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="任务开始日期" prop="startTime" show-overflow-tooltip width="180">
          <template slot-scope="scope">
            {{ scope.row.startTime && dayjs(scope.row.startTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column label="任务结束日期" prop="endTime" show-overflow-tooltip width="180">
          <template slot-scope="scope">
            {{ scope.row.endTime && dayjs(scope.row.endTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column
          label="任务来源"
          prop="taskDetailsTypeStr"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="超期未排查次数"
          prop="troubleshootingOverdueCount"
          width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="70">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <OverdueDialog
      type="base"
      :formData="formData"
      @refreshList="findList()"
      v-if="formDialog"
      @cancel="formDialog = false"
    ></OverdueDialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { HiddenDangerInvestigationTaskApi } from '@wiz-api/double-prevention-management'
import { AreaApi } from '@wiz-api/area-management'
import { UserApi } from '@wiz-api/abp-identity'
import utils from '@/components/safety/enumField/utils'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import OverdueDialog from './OverdueDialog'

const areaApi = new AreaApi()
const userApi = new UserApi()
const hiddenDangerInvestigationTaskApi = new HiddenDangerInvestigationTaskApi()

export default {
  name: 'overdue-task-base-table',
  components: {
    TableOperateButton,
    OverdueDialog,
  },
  data() {
    return {
      formData: {},
      formDialog: false,
      currentRow: null,
      currentComp: 'TABLE',
      userList: [],
      pageNo: 1,
      pageSize: 15,
      levelList: [],
      areaList: [],
      checkTypeList: [],
      unitCycleList: [],
      // 设备设施清单
      tableData: [],
      loading: false,
      total: 0,
      searchData: {
        keywords: '',
        organizationLevel: null,
        deadlinePersonId: undefined,
        troubleshootingType: null,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
        ]
      }
    },
    // 排查周期
    unitCycleListMap() {
      return (val) => {
        return (
          this.unitCycleList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    checkTypeListMap() {
      return (val) => {
        return (
          this.checkTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  created() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
        'DoublePreventionManagement.DataCategory.CheckType',
        'DoublePreventionManagement.DataCategory.UnitCycle',
      ],
      ['levelList', 'checkTypeList', 'unitCycleList'],
      this
    )
    this.searchList()
    this.getAreaList()
    this.getUserList()
  },
  methods: {
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 列表操作-事件 设备设施清单
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'read':
          // 没有新增获取数据
          this.formData = this.$options.data().formData
          this.formData = row
          this.formDialog = true
          break

        default:
          break
      }
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await userApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    // 搜索 equip 设备设施 job 作业活动
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetText() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    // 设备设施列表
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        isOverdue: true,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await hiddenDangerInvestigationTaskApi.taskBasicManagementPagedListQuery(
        data
      )
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style></style>
